import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { "data-test": "dlm-message" }
const _hoisted_2 = { class: "controls" }

import { computed } from "vue";
import { Modal } from "uiv";
import { LicenceApiModel } from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'delete-licence-modal',
  props: {
    memberWithLicence: {},
    showLicenceModal: { type: Boolean }
  },
  emits: ["toggle-licence-modal", "delete-licence"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showModal = computed(() => {
  return props.showLicenceModal;
});

const toggleLicenceModal = (): void => {
  emit("toggle-licence-modal");
};

const removeLicenceForMember = (id: string) => {
  emit("delete-licence", id);
};

return (_ctx: any,_cache: any) => {
  return (props.memberWithLicence)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
        header: false,
        "data-test": "dlm-modal"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: toggleLicenceModal,
              "data-test": "dlm-cancel-btn",
              type: "button"
            }, " Cancel "),
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (removeLicenceForMember(_ctx.memberWithLicence.id))),
              "data-test": "dlm-delete-btn",
              type: "button"
            }, " Delete ")
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("h2", _hoisted_1, " Are you sure you want to delete ‘" + _toDisplayString(_ctx.memberWithLicence.licensee.firstName) + "'s licence? ", 1)
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})